angular.module('mtic.components.modules.generalModuleMap').
directive('moduleMetaMap', function(
  GR78_ASSET_URL,
  C4_ASSET_URL,
  AGENDA_ASSETS_URL,
  DEV_VARIABLES,
  StudentDataService,
  PanelStateService,
  $timeout,
  TIMING_CONSTANTS,
  TeacherDataService,
  $q,
  $log,
  $http,
  $window,
  itemFactory,
  MapDataMassage,
  MapStateService,
  VerletSystemService,
  learningMapUtil,
  PIXI,
  EventManager,
  language,
  flashPermission,
  userAccount,
  preliveCheck,
  LocaleService,
  ModuleFilter,
  C3_ASSET_URL,
  PlatformService,
  PanelFactory,
  $rootScope
) {

  return {

    templateUrl: 'template.html',
    scope: {
      moduleMapData: "=",
      interceptClick: "=?",
      onItemClick:"<",
      workspaceData:"=?",
      interactionDisabled:"=?",
    },
    link: function(scope, element) {
      scope.getTranslation = function(id){
        return language.get(id);
      }
      scope.badBrowser = false;
      var middle_view_visible = false;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }

      scope.isTeacher = userAccount.getData().role.isTeacher;
      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78MetaMap', scope);
      var verlet_system = new VerletSystemService();

      scope.goBackToClasses = function(){
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');        
      }
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var state = 0,leftMostMapItemPosition=0,rightMostMapItemPosition=0,topMostMapItemPosition=0,allSummativeItems=[],languageOptions=[];
      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimention = null;
      var scale = null;
      var stage = null;
      var meta_background = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var cloud_man = null;
      var items = [];
      var modules = [];
      var moduleContainerManager;
      var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));
      var bg_images;

      var agendas_list = [];

      var img_asset_paths = [];

      // [
      //   GR78_ASSET_URL + "symlink.png",
      //   GR78_ASSET_URL + "item_blue_0.png",
      //   GR78_ASSET_URL + "item_blue_1.png",
      //   GR78_ASSET_URL + "item_red_0.png",
      //   GR78_ASSET_URL + "item_red_1.png",
      //   GR78_ASSET_URL + "item_red_2.png",
      //   GR78_ASSET_URL + "item_red_3.png",
      //   GR78_ASSET_URL + "item_black_0.png",
      //   GR78_ASSET_URL + "item_black_1.png",
      //   GR78_ASSET_URL + "item_black_2.png",
      //   GR78_ASSET_URL + "item_black_3.png",
      //   GR78_ASSET_URL + "item_blue_locked.png",
      //   GR78_ASSET_URL + "item_red_locked.png",
      //   GR78_ASSET_URL + "item_black_locked.png",
      //   GR78_ASSET_URL + "assessment.png",
      //   GR78_ASSET_URL + "assessment_complete.png",
      //   GR78_ASSET_URL + "selection.png",
      //   GR78_ASSET_URL + "mtic_gr78_m0.png",
      //   GR78_ASSET_URL + "mtic_gr78_m1.png",
      //   GR78_ASSET_URL + "mtic_gr78_m2.png",
      //   GR78_ASSET_URL + "mtic_gr78_m3.png",
      //   GR78_ASSET_URL + "mtic_gr78_m4.png",
      //   GR78_ASSET_URL + "mtic_gr78_c4_m1.png",
      //   GR78_ASSET_URL + "mtic_gr78_c4_m6.png",
      //   GR78_ASSET_URL + "formative_gold.png",
      //   GR78_ASSET_URL + "formative_silver.png",
      //   GR78_ASSET_URL + "formative_locked.png",
      //   GR78_ASSET_URL + "formative_unlocked.png",

      //   C4_ASSET_URL + "run_like_math_item_0.png",
      //   C4_ASSET_URL + "run_like_math_item_1.png",
      //   C4_ASSET_URL + "run_like_math_item_2.png",
      //   C4_ASSET_URL + "run_like_math_item_3.png",
      //   C4_ASSET_URL + "run_like_math_item_4.png",
      //   C4_ASSET_URL + "run_like_math_item_locked.png",

      //   C3_ASSET_URL + "map.png",
      //   C3_ASSET_URL + "m34_map.png",
      //   C3_ASSET_URL + "m56_map.png",
      //   C3_ASSET_URL + "star.png",
      //   C3_ASSET_URL + "item_blue_0.png",
      //   C3_ASSET_URL + "item_blue_1.png",
      //   C3_ASSET_URL + "item_red_0.png",
      //   C3_ASSET_URL + "item_red_1.png",
      //   C3_ASSET_URL + "item_red_2.png",
      //   C3_ASSET_URL + "item_red_3.png",
      //   C3_ASSET_URL + "item_black_0.png",
      //   C3_ASSET_URL + "item_black_1.png",
      //   C3_ASSET_URL + "item_black_2.png",
      //   C3_ASSET_URL + "item_black_3.png",
      //   C3_ASSET_URL + "item_blue_locked.png",
      //   C3_ASSET_URL + "item_red_locked.png",
      //   C3_ASSET_URL + "item_black_locked.png",
      //   C3_ASSET_URL + "item_af_locked.png",
      //   C3_ASSET_URL + "item_af.png",
      //   C3_ASSET_URL + "item_test.png",
      //   C3_ASSET_URL + "assessment.png",
      //   C3_ASSET_URL + "assessment_complete.png",
      //   C3_ASSET_URL + "item_test_locked.png",

      //   "assets/images/ocmt/ocmt_item_0.png",
      //   "assets/images/ocmt/WholeNumbers_diagnostic_icon.png",
      //   "assets/images/ocmt/WholeNumbers_diagnostic_icon_unlocked.png",
      //   "assets/images/ocmt/WholeNumbers_summative_icon.png",
      //   "assets/images/ocmt/WholeNumbers_summative_icon_unlocked.png",
      //   "assets/images/ocmt/ocmt_item_locked.png",
      //   "assets/images/ocmt/selection_m1.png",
      //   "assets/images/ocmt/selection.png",
      // ]
      var focus_item = null;

      scope.hasAgendas = false;
      scope.loadedIframeModule = {
        active: false,
        data: []
      }
      scope.moduleProgress = 0.5;

      flashPermission.getPermission();

      var runDownModel = {}
      var highlightedItem = null;

      var zooming = false;
      
      var update_texts = []; var update_direction = 0.002;

      var resourceLockManager = (function ResourceLockManager(self){
        var originalLockState = {};
        self.setOriginal = function(resourceId, isLocked){
          if(!originalLockState[resourceId]) {
            originalLockState[resourceId] = isLocked;
          }
        }
        self.unlock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if(item) {
              item.unlock();
            }
          })
        }
        self.lock = function(resourceIds) {
          self.reset();
          resourceIds.forEach(function(resourceId){
            var item = getItemById(resourceId);
            if (TeacherDataService.isTeacherModuleView){
              item.unlock();
            }
            else{
              if(item) {
                item.lock();
              }
            }
          })
        }
        self.reset = function() {
          items.forEach(function(item){
            if (TeacherDataService.isTeacherModuleView){
              item.unlock();
            }
            else{
              if(originalLockState[item.id] === true) {
                item.lock();
              }
              else if(originalLockState[item.id] === false) {
                item.unlock();
              }
            }
          });
        }
        return self;
      })({})

      scope.showAgenda = true;
      scope.selectedResource = {};
      function unlockpath(item_id, use_slug){
        // $log.log('UNLOCK PATH : ', item_id )
        items.forEach(function(resource){
          if(resource.id === item_id || (use_slug && item_id === resource.slug)){
            resource.unlock();
            resource.unlockedByAgenda = true;
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                unlockpath(higher_resource, true);
              })
            }
          }
        })
      }

      eventManager.listen('moduleview:agenda:loaded', function(e, data){
        // $log.log('agenda data : ', data)
        if (data.length > 0)
        {
          agendas_list = data;
          scope.hasAgendas = true;
          scope.selectAgendaPanel();
          data.forEach(function(agenda){
            if(agenda.force_unlock){
              if(agenda.force_unlock){
                agenda.resources.forEach(function(item){
                  unlockpath(item);
                })
              }
            }
          })
        } else {
          scope.hasAgendas = false;
          scope.selectModulePanel();
        }
      });

      scope.hasAgendaOption = function(){
        return scope.hasAgendas;
      }
      scope.hasModuleOption = function(){
        return scope.currentActiveSubModule && scope.currentActiveSubModule.children ;
      }

      scope.isShowingAgendaPanel = function(){
        return scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView;
      }
      scope.isShowingModulePanel = function(){
        //&& scope.hasModuleOption()
        return (!scope.showAgenda  && !TeacherDataService.isTeacherWorkspaceView) || scope.isTeacher;
      }

      scope.toggleAgenda = function() {
        if (scope.showAgenda) {
          scope.selectModulePanel();
        }
        else {
          scope.selectAgendaPanel();
        }
      }

      scope.selectAgendaPanel = function(){
        // $log.log('from select agenda panel')
        if(!scope.hasAgendas){
          return;
        }
        scope.showAgenda = true;
        PanelStateService.setAgendaShowing(scope.showAgenda);
        if (!scope.showAgenda){
          eventManager.broadcast('moduleview:agenda:request');
        }
      }

      scope.selectModulePanel = function(){
        // $log.log('from select module panel')
        if (scope.showAgenda){
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          for (var i = 0; i < items.length; i++) {
            items[i].undoAgendaHighlight();
          }
        }
      }

      scope.panelDisplay = {};
      scope.getLang = language.get;

      scope.isStudent = function(){
        return !userAccount.getData().role.isTeacher;
      }

      /////////////
      // CONSTRUCTOR
      /////////////

      var _TOUCHED_POINTS = []
      var map_config = {};
      var default_scale = 0.45;
      var default_map_configs = {
        background_color: 0xdee9fc,
        hide_bottom_panel: false,
        gradient_start: '#7DC5BA',
        gradient_stop: '#A0E0DA',
        meta_background_visible: true,
        disable_verlet: false,
        map_style: 'gr78',
        line_options: {
          disabled:false,
          color: 0xCCCCDD,
          offset_y: 0,
          line_size: 8
        },
        tooltip_options: {
          fontcolor: 0xFFFFFF,
          inverted: false,
          color: 0xdae2ea,
          locked_color:0x63a19a,
          item_fillcolor: 0x3B5763,
          bar_color:0x075a8f,
          bar_fill_color:0x33ccff,
          always_visible: false,
          no_bar: false
        },
        selector_options:{
          disabled: false,
          offset_y: 0,
          disable_size_shifting: false,
          start_scale: 1,
          rotation_speed: 0.015
        },
        disable_zoom: false
      }
      function init() {
        scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
        // retrieve template element references
        canvas_el = document.getElementById('module-item-map-canvas');
        if (!canvas_el) {
          return;
        }

        MapStateService.setMetaStateSlug(scope.moduleMapData.resource_slug)
        map_config = scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config ? _.extend(_.clone(default_map_configs), scope.moduleMapData.meta_config.map_config) : default_map_configs;
        map_config.asset_url = map_config.asset_url || GR78_ASSET_URL;

        if(map_config.unlock_by_diagnostic){
          unlock_lessons_by_diagnostic();
        }

        if(map_config.disable_verlet){
          verlet_system.toggle(false);
        }

        scope.hide_bottom_panel = map_config.hide_bottom_panel;

        img_asset_paths = map_config.img_assets || [];
        for(var i =0;i<img_asset_paths.length;i++){
          if(img_asset_paths[i].indexOf(map_config.asset_url) === -1){
            img_asset_paths[i] = map_config.asset_url + img_asset_paths[i];
          }
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: map_config.background_color,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = default_scale;
        items = [];

        drag_info = learningMapUtil.getDragInfoSettings();

        canvasDimention = {
          width: 0,//window.innerWidth - 180 - sidepanel_width,
          height: window.innerHeight - 50,
        }
        stage = app.stage;
        stage.interactive = true;

        cloud_man = learningMapUtil.createCloudManager();
        stage.addChild(cloud_man.overlay_sprite);

        var meta_canvas = document.createElement("canvas");
        meta_canvas.width = 200;
        meta_canvas.height = 200;
        var ctx = meta_canvas.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 200);
        gradient.addColorStop(0, map_config.gradient_stop);
        gradient.addColorStop(1, map_config.gradient_start);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 200, 200);

        var meta_tex = PIXI.Texture.fromCanvas(meta_canvas);

        meta_background = new PIXI.Sprite(meta_tex);

        stage.addChildAt(meta_background, 0);

        window.addEventListener("resize", onResize);

        // var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null
        // onResize(isExpanded);
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;

        stage.addChildAt(container, 1);
        toggle_mapconfig();

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        container.scale.set(scale, scale);
        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else

        // prevent browser from selecting other html text when double clicking the PIXI canvas
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);
        // scope.test_data = 'TESTING';
        stage.on('pointerdown', function(e) {
          if((map_config && map_config.disable_panning) || (scope.currentActiveSubModule && scope.currentActiveSubModule.config  && scope.currentActiveSubModule.config.map_config && scope.currentActiveSubModule.config.map_config.disable_panning)){
            return;
          }
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x:e_o.pageX, y:e_o.pageY});

          drag_info.dragging = true;
          focus_item = null;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
          // scope.agendaImgBox = document.getElementById('agendaImgBox')        

        });
        stage.on('pointermove', function(e) {
          if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
            var mouse_pos = {
              x: e.data.global.x,
              y: e.data.global.y
            }
            container.position.x = Math.min(1000, Math.max(drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x), 0));
            container.position.y = Math.min(1000, Math.max(drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y), 0));
            var delta_pos = {
              x: drag_info.last_mouse_pos.x - mouse_pos.x,
              y: drag_info.last_mouse_pos.y - mouse_pos.y
            };
            // if(scope.agendaImgBox){
            //   if(container.position.x > 0 && container.position.x < 1000){
            //     scope.agendaImgBox.style.left = scope.agendaImgBox.style.left.replace('px', '') - delta_pos.x + 'px'
            //   }              
            //   if(container.position.y > 0 && container.position.y < 1000){
            //     scope.agendaImgBox.style.top = scope.agendaImgBox.style.top.replace('px', '') - delta_pos.y + 'px'
            //   }
            // }
            drag_info.velocity = {
              x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
              y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
            };
            drag_info.last_mouse_pos = {
              x: mouse_pos.x,
              y: mouse_pos.y
            };
          }
        })
        stage.on('pointerup', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info)); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        stage.on('pointerout', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerup ; ', JSON.stringify(drag_info)); }
          drag_info.dragging = false;

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
          prev_diff = null;
        });

        if(PIXI.loader.resources){
          for(var ast in PIXI.loader.resources){
            PIXI.loader.reset();
            PIXI_gr78_Load_Cache = false;
            break;
          }
        }
        

        if (window.DEBUG_TOUCH){ $log.log('g78_metamap pointerdown ; ', JSON.stringify(drag_info)); }
        return loadAssets().then(function() {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          scope.loading_done = true;
          var isExpanded = TeacherDataService.inTeacherAgendaView ? false : null;
          $timeout(function(){            
            if(window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened){
              var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
              var item_id = urlParams.get('item_id')
              if(item_id === 'LEADERBOARD'){
                eventManager.broadcast('activate:leaderboard')
              }else{
                item_id = Number(item_id)
                var item_to_open = getItemById(item_id);
                if(item_to_open){    
                  var parent_resource = getResourceById(getResourceBySlug(item_to_open.slug).parent_resource_id);           
                  eventManager.broadcast('submodule:opened', {
                    slug: parent_resource.slug,
                    name: parent_resource.name
                  })
                  eventManager.broadcast('module:open:resource',_.pick(item_to_open, 'slug', 'id', 'parent_resource_id', 'name', 'container', 'content', 'config', 'type'));
                }else{
                  //display error here                 
                  window.alert(language.get('item_links_missing_item').replace('__', urlParams.get('item_id')))
                }
              }
            }
            onResize(isExpanded);
          }, 300)
          return;
        }).catch(function(err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message)
          $log.debug(err.stack)
        });

      }

      scope.returnToMetaModules = function() {
        scope.loadedIframeModule.active = false;
        eventManager.broadcast('module:change:meta', scope.moduleMapData.resource_slug);
      }


      function unlock_lessons_by_diagnostic(){
        _.each(scope.moduleMapData.resources, function(submod){
          if(submod.children){
            var unlock_by_diag = false;
            var lock_summative = false;
            _.each(submod.children, function(lesson){
              if(lesson.config.assessment_type && lesson.config.assessment_type === 'diagnostic' && lesson.resourceState && lesson.resourceState.score_max >= 0.8){
                unlock_by_diag = true;
                lock_summative = lesson.resourceState.score_max === 1;
              }
            })
            if(unlock_by_diag){
              _.each(submod.children, function(lesson){
                if(lesson.config.assessment_type && lesson.config.assessment_type === 'summative' && (!lesson.resourceState || !lesson.resourceState.complete)){
                  lesson.locked = lock_summative;
                  if(lock_summative){
                    lesson.complete = true;
                    if(!lesson.resourceState){
                      lesson.resourceState = {};
                    }
                    lesson.resourceState.complete = true;
                    lesson.resourceState.scoreMax = 1;
                  }
                }else if(!lesson.config.assessment_type){
                  lesson.locked = false;
                  lesson.complete = true;
                  if(!lesson.resourceState){
                    lesson.resourceState = {};
                  }
                  lesson.resourceState.complete = true;
                  lesson.resourceState.scoreMax = 1;
                }
              })
            }
          }
        })
      }

      function toggle_mapconfig(){
        // toggles map_config between cycle and submodules
        meta_background.visible = map_config.meta_background_visible;
        renderer.backgroundColor = Number(map_config.background_color);
        scope.disable_zoom = map_config.disable_zoom;
        scope.overlay_options = map_config.overlay_options;
        if(scope.disable_zoom){
          scale = default_scale;
          container.scale.set(default_scale, default_scale);
        }
        //remove all images
        if(bg_images && bg_images.length > 0){
          _.each(bg_images, function(img){
            if(img.reference && img.reference.parent){
              img.reference.parent.removeChild(img.reference);
            }
          })
        }
        bg_images = [];
        //add images
        if(map_config.background_images){
          _.each(map_config.background_images, function(img){
            //$log.log('adding image : ', img)
            var bg_img
            if(img.type === 'regular'){
              bg_img = PIXI.Sprite.fromImage(map_config.asset_url + img.name);
            }else if(img.type === 'tiling'){
              bg_img = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(map_config.asset_url + img.name));
            }
            if(bg_img && (img.anchor_x || img.anchor_x === 0) && (img.anchor_y || img.anchor_y === 0)){
              bg_img.anchor.set(img.anchor_x, img.anchor_y);
            }
            bg_images.push({config: img, reference: bg_img});
            if (img.is_container_image && container) {
              container.addChildAt(bg_img, 0);
            }
            else {
              stage.addChildAt(bg_img, 1);
            }
          })
        }
        onResize();
        if(map_config.start_pan){          
          container.position.x += map_config.start_pan.x;
          container.position.y += map_config.start_pan.y;
        }
      }
      function reset_mapconfig(){
        map_config = scope.moduleMapData.meta_config && scope.moduleMapData.meta_config.map_config ? _.extend(_.clone(default_map_configs), scope.moduleMapData.meta_config.map_config) : default_map_configs;
        toggle_mapconfig();
      }

      eventManager.listen('module:change:meta', function(e, data) {
        $timeout(function() {
          //Remove the focus from the selected item
          eventManager.broadcast('module:dismiss:focus');
          language.setAvailableOptions(
            _.get(scope.moduleMapData, ['content', 'available_languages', LocaleService.getUrlVersion()])
          );
          if(scope.currentActiveSubModule && scope.currentActiveSubModule.config && scope.currentActiveSubModule.config.map_config){
            reset_mapconfig();
          }
          scope.currentActiveSubModule = {};
          scope.panelDisplay = {
            slug: '',
            isExpanded: false,
            sub: {}
          };

          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < modules.length; i++) {
            verlet_system.activateBody(modules[i].slug, true);

            modules[i].graphics.interactive = true;
          }
          onResize();

          //no active module
          MapStateService.setActiveModule("");
          MapStateService.setCurrentItemLang("");
        },TIMING_CONSTANTS.INSTANT);
      });

      eventManager.listen('unlock-item', function(e, slug){
        items.forEach(function(resource){
          if(slug === resource.slug){
            resource.unlock(true);
            resource.unlockedByAgenda = true;
          }
        })
        // var scopeResource = getResourceBySlug(slug);
        // scopeResource.locked = false;
      })
      eventManager.listen('module:change:submodule', function(e, data) {
        $timeout(function() {
          verlet_system.deactivateAllBodies(true);

          MapStateService.setActiveModule(data);
          var resources = MapStateService.getSelectedResourcesForAgendaCreation();
          var use_resources = scope.moduleMapData.resources;
          if(data.indexOf('run_like_math_') > -1 && scope.moduleMapData.module_id === 11) {
            for (var j = 0; j < scope.moduleMapData.resources.length; j++) {
              if (scope.moduleMapData.resources[j].slug === 'run_like_math') {
                use_resources = scope.moduleMapData.resources[j].children;
              }
            }
          }
          for (var i = 0; i < use_resources.length; i++) {
            if (use_resources[i].slug === data) {
              if(scope.currentActiveSubModule && scope.currentActiveSubModule.config && scope.currentActiveSubModule.config.map_config && !use_resources[i].map_config){
                //if going from module with map config to one without, reset to default parents config
                reset_mapconfig();
              }
              scope.currentActiveSubModule = use_resources[i];              
              if(scope.currentActiveSubModule && scope.currentActiveSubModule.id === 192 && scope.currentActiveSubModule.children){
                scope.currentActiveSubModule.resources = scope.currentActiveSubModule.children;
              }
              if(scope.currentActiveSubModule.config.map_config){
                map_config = _.extend(map_config, scope.currentActiveSubModule.config.map_config)
                toggle_mapconfig();
              }
              var resource = use_resources[i];
              for (var n = 0; n < resource.children.length; n++) {
                //unselect any highlited item
                var item = getItemBySlug(resource.children[n].slug);
                if(item && TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView)
                {
                    item.hideAgendaHighlight();
                }
                // if((resources && resources.contains && resources.contains(item.id))){
                //   item.showAgendaHighlight();
                // }
                if (DEV_VARIABLES.RESOURCES.HIDE_THESE.indexOf(resource.children[n].slug) > -1 || (resource.children[n].config && resource.children[n].config.hidden===true))
                {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
          eventManager.broadcast('log:language:options', {
            available_language: scope.currentActiveSubModule.content.available_languages || 'none',
            current_url_version: LocaleService.getUrlVersion(),
            cycle: 'gr78'
          })
          language.setAvailableOptions(
            _.get(scope.currentActiveSubModule, ['content', 'available_languages', LocaleService.getUrlVersion()])
          );
          if(MapStateService.getCurrentItemLang() && MapStateService.getCurrentItemLang() !== language.getCurrentSelectedLanguage()){
            language.set(MapStateService.getCurrentItemLang());
          }
          if (!scope.hasAgendaOption()){
            scope.selectModulePanel();
          }
          // $log.log('from current active sub : ', scope.currentActiveSubModule)

          let isVerletNeeded = !map_config.disable_verlet;
          if ((map_config.disable_verlet) || (scope.currentActiveSubModule.display && scope.currentActiveSubModule.display.isVerletDisabled)){
            isVerletNeeded = false;
          }
          verlet_system.toggle(isVerletNeeded);
          // $log.log('verlate is active : ' , isVerletNeeded, verlet_system.getCurrentEnabledStatus())

          if (scope.currentActiveSubModule.display.panel && scope.currentActiveSubModule.display ) {
            scope.panelDisplay = {
              slug: scope.currentActiveSubModule.slug,
              isExpanded: true,
              sub: scope.currentActiveSubModule.display.panel
            };
          }

          if(bg_images && bg_images.length > 0){
            _.each(bg_images, function(img){
              if(img.config.hide_in_submodule){
                img.reference.visible = false;
              }
            })
          }
          
        }, TIMING_CONSTANTS.INSTANT);
      })

      eventManager.listen('module:open:resource', function(e, data){
        MapStateService.setFocusSlug(data.slug);
        MapStateService.setCurrentItemLang(language.getCurrentSelectedLanguage())
      })

      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function(e,list){
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
        $timeout(function(){
          onResize();
        }, 500)
      });

      eventManager.listen('module:select:resource', function(e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null)
        {
          eventManager.broadcast('module:dismiss:focus')
          return;
        }

        if(scope.onItemClick && scope.interceptClick){
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource,item, data);
          // return;
        }
        $timeout(function(){
          scope.selectedResource = scopeResource;
        }, TIMING_CONSTANTS.INSTANT);

        var mapResource = getItemBySlug(data.slug);
        if(scope.itemResource && scope.itemResource !== mapResource && map_config.map_style === 'ocmt'){
          scope.itemResource.endRotation();
        }
        scope.itemResource = mapResource;

        //This isn't a map item??
        if (mapResource === null)
        {
          return;
        }

        focus_item = mapResource;

        scope.scale_factor = focus_item && focus_item.type === 'assessment' && focus_item.config.assessment_type !== 'formative' ? 9.6 : 10;

        if(map_config.map_style !== 'ocmt' && selection_graphic){
          mapResource.sprite.addChildAt(selection_graphic, 0);
          selection_graphic.scale.set(0);
        }      

        //Find the module that contains the selected item and open it
        var module_slug = '';
        for (var i = 0; i < scope.moduleMapData.resources.length; i++)
        {
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1 )
          {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug)
            {
              eventManager.broadcast('module:change:submodule', scope.moduleMapData.resources[i].slug);
              eventManager.broadcast('update:submodule:slug:route:name',{slug:scope.moduleMapData.resources[i].slug,name:scope.moduleMapData.resources[i].name});
              MapStateService.setActiveModule(scope.moduleMapData.resources[i].slug);
            }
          }
        }


        if(TeacherDataService.inTeacherAgendaView){
          if(!middle_view_visible){
            middle_view_visible = true; 
          }           
        }
      })

      eventManager.listen('module:center:resource', function(e, data) {
        if(data.map_config && (data.map_config.disable_panning || data.map_config.disable_auto_pan)){
          return
        }
        focus_item = getItemBySlug(data.slug);
      })

      eventManager.listen('module:stop:pan', function() {
        focus_item = null;
      })
      
      // eventManager.listen('agenda:show:image', function(e, img_url){        
      //   if(TeacherDataService.inTeacherAgendaView){
      //     $log.log('GOT IMAGE : ', img_url)
      //     scope.agenda_box_graphic.removeChildren();

      //     var texture = PIXI.Texture.from(img_url);
      //     var agenda_img = new PIXI.Sprite(texture);
      //     scope.agenda_box_graphic.addChild(agenda_img)
      //     agenda_img.width = 880
      //     agenda_img.x = 10;
      //     agenda_img.y = 60;
      //   }
      // })

      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function(evt) {
        if (!evt || map_config.disable_zoom) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = container.scale.x;
        scale = Math.max(Math.min(1.0, start_scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);
        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        // var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        // container.position.x -= diff * pos.x;
        // container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};
        // $log.log("modulemapdata : ", moduleMapData)

        _.forEach(moduleMapData.children, function(someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        })

        var currentModuleChildrenDisplayItems = [];
        _.each(combinedResourceMap, function(resource) {
          var item = createItem(resource, moduleMapData.config);
          if(!item){
            return;
          }
          currentModuleChildrenDisplayItems.push(item);
          if(item.sprite && item.sprite.position  && item.sprite.position.x<leftMostMapItemPosition){
            leftMostMapItemPosition = item.sprite.position.x;
          }
          if(item.sprite &&item.sprite.position && item.sprite.position.x && item.sprite.position.x>rightMostMapItemPosition){
            rightMostMapItemPosition = item.sprite.position.x;
          }
          if(item.sprite && item.sprite.position && item.sprite.position.y && item.sprite.position.y<topMostMapItemPosition){
            topMostMapItemPosition = item.sprite.position.y;
          }
        });

        // $log.log('currentModuleChildrenDisplayItems : ', moduleMapData)

        var summativeItem = _.find(currentModuleChildrenDisplayItems,function(each){
          return each.slug.indexOf('sum')>-1 && each.resource_type === 'assessment';
        });
        if(summativeItem){
          //  $log.log('summative g78 : ', summativeItem)
          summativeItem.sprite.position.set((leftMostMapItemPosition + (rightMostMapItemPosition-leftMostMapItemPosition)/2)-summativeItem.sprite.width/2,(topMostMapItemPosition -150));
          summativeItem.initialX = summativeItem.sprite.position.x;
          allSummativeItems.push(summativeItem);
        }

        _.forEach(items, function(item) {
          if (!item.locked) {
            item.unlock();
          }
          if (MapDataMassage.getTempUnlocks()) {
            if (_.indexOf(MapDataMassage.getTempUnlocks(), item.slug) !== -1) {
              item.unlock();
            }
          }
        })

        if(agendas_list.length > 0){
          agendas_list.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })
        }
      };

      var updateItemsHighlighterAnimation = function(){
        angular.forEach(items,function(each){
          if(each.selection_graphic){
            //Rotate it a little bit
            each.selection_graphic.rotation = (each.selection_graphic.rotation-0.015)%(Math.PI*2);
            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            var scale_factor = each.type === 'assessment' && each.config.assessment_type !== 'formative' ? 9.6 : 10
            each.selection_graphic.scale.set((each.selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scale_factor);
          }
          if(each.highlight_graphic){
            //Rotate it a little bit
            each.highlight_graphic.rotation = (each.highlight_graphic.rotation-0.015)%(Math.PI*2);

            //Use UNIX time to scale the graphic with a sin function
            //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
            each.highlight_graphic.scale.set((each.highlight_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /10);
          }

        });
      }

      var prev_diff;

      //This loops to control things that should update every frame
      var update = function() {
        if (selection_graphic && map_config.selector_options && map_config.selector_options.disable_module_selection) {
          selection_graphic.visible = false;
        }
        else if (selection_graphic) {
          selection_graphic.visible = true;
        }

        if(selection_graphic !== null && !scope.interceptClick && map_config.map_style !== 'ocmt' && (!map_config.selector_options || !map_config.selector_options.disable_animations))
        {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation-map_config.selector_options.rotation_speed)%(Math.PI*2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          var selection_scale = map_config.selector_options.disable_size_shifting ? map_config.selector_options.start_scale : (selection_graphic.scale.x * 9 + (0.8+Math.sin(Date.now()/500.0)/10)) /scope.scale_factor
          selection_graphic.scale.set(selection_scale);
          selection_graphic.y = map_config.selector_options.offset_y;
        }else if(map_config.map_style === 'ocmt' && scope.itemResource){
          scope.itemResource.rotateRing();
        }

        if(TeacherDataService.isTeacherWorkspaceView && (!map_config.selector_options || !map_config.selector_options.disable_animations)){
          updateItemsHighlighterAnimation();
        }
        else if (TeacherDataService.isTeacherWorkspaceView && map_config.selector_options && map_config.selector_options.disable_animations) {
          var itemScale = map_config && map_config.icon_options && map_config.icon_options.item_icon_scale ? map_config.icon_options.item_icon_scale : 1.0;

          angular.forEach(items,function(each){
            if(each.selection_graphic){
              // reset rotation and scale of item selection icon
              each.selection_graphic.rotation = 0;

              var scale_size = 0.75;
              var selector_scale = map_config.selector_options && map_config.selector_options.selector_scale ? map_config.selector_options.selector_scale : scale_size;
              each.selection_graphic.scale.set(selector_scale*itemScale, selector_scale*itemScale);
            }
          });
        }
        //update the fade in animation
        cloud_man.update();

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();

        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };
        } else {
          container.position.x = Math.min(1000, Math.max(container.position.x - drag_info.velocity.x, 0));
          container.position.y = Math.min(1000, Math.max(container.position.y - drag_info.velocity.y, 0));
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }

        focusItemTicker();

        lines_graphic.clear();
        if(!map_config.line_options.disabled){
          var line_color = Number(map_config.line_options.color);
          lines_graphic.lineStyle(8, line_color, 1);
          var segments = verlet_system.getLineSegments();
          var i;
          for (i = 0; i < segments.solid.length; i++) {
            var cur_seg = segments.solid[i];
            var start_point = map_config.line_options.offset_y || cur_seg.start.y;
            var end_point = map_config.line_options.offset_y || cur_seg.end.y;
            lines_graphic.lineStyle(map_config.line_options.line_size, line_color, 1);
            if(scope.item_path_slug.indexOf(cur_seg.id) > -1){
              lines_graphic.lineStyle(map_config.line_options.line_size, 0XFFCC00, 1);
            }
            lines_graphic.moveTo(cur_seg.start.x, start_point);
            lines_graphic.lineTo(cur_seg.end.x, end_point);
          }
          lines_graphic.beginFill(0xFF0000, 1);
          for (i = 0; i < segments.dash.length; i++) {
            lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
          }
          lines_graphic.endFill();
        }

        if(update_texts.length > 0){
          update_direction = update_texts[0].scale.x >= 1.1 ||  update_texts[0].scale.x < 1 ? update_direction * -1 : update_direction;
          update_texts.forEach(function(update_text){
            update_text.scale.x += update_direction;
            update_text.scale.y += update_direction;
            update_text.alpha = 1 - 2.5*(1.1 - update_text.scale.x);            
            update_text.x += update_direction * -1;
          })
        }

        if (window.DEBUG_TOUCH){ $log.log('g78_metamap update ; ', JSON.stringify(drag_info)); }
      };

      scope.item_path_slug = [];
      function createHighlightedSegments(slug){
        if(!slug){
          scope.item_path_slug = [];
          return;
        }
        items.forEach(function(resource){
          if(slug === resource.slug){
            scope.item_path_slug.push(slug);
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                createHighlightedSegments(higher_resource);
              })
            }
          }
        })
        // $log.log('scope.item_path_slug , ', scope.item_path_slug)
      }

      eventManager.listen('highlight:path', function(e, data){
        scope.item_path_slug = [];
        // $log.log('HIGHLIGHT THIS : ', data)
        // var use_slug = data.slug.split(':')[1].trim();
        var use = data.slug;
        if(data.clear){
          use = false;
        }
        createHighlightedSegments(use);
      })

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function(slug) {
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
          // toggleGroupExpanded(group);
        }
      }

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      }

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      }

      //If focus item is defined, pan towards it
      var focusItemTicker = function() {
        if (focus_item === null || map_config.disable_panning || map_config.disable_auto_pan || !scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      }

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      }

      var getItemById = function(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      }

      var getResourceBySlug = function(slug)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          if (scope.moduleMapData.resources[n].slug === slug)
          {
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++)
          {
            if (scope.moduleMapData.resources[n].children[i].slug === slug)
            {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      }

      var getResourceById = function(id)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          if (scope.moduleMapData.resources[n].id === id)
          {
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++)
          {
            if (scope.moduleMapData.resources[n].children[i].id === id)
            {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      }

      ////////////////
      //
      ////////////////
      var onResize = function(sidepanel_expanded) {
        var _canvasEl = document.getElementById('module-item-map-canvas')
        if (!_canvasEl) {
          return;
        }

        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
        var canv_width;
        scope.agendaView = TeacherDataService.inTeacherAgendaView;

        if(!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          if(sidepanel_expanded === true || sidepanel_expanded === false){
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          }else{
            sidepanel_width = 0;
          }
          canv_width =  (PlatformService.isPhonePortrait() ?  window.innerWidth : _canvasEl.parentElement.offsetWidth) - sidepanel_width;
        }else{
          var middleview = document.getElementById('agenda_middleview');
          if(middleview){
            sidepanel_width += 300
          }
          if(!TeacherDataService.inTeacherAgendaView){
            sidepanel_width += -30;
          }
          if(window.innerWidth < 1225){
            sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
          }

          var sidebarWidth = 370
          var agendaSplitViewSidebar = document.getElementById('agendaSplitViewSidebar')
          if(agendaSplitViewSidebar){
            sidebarWidth = agendaSplitViewSidebar.offsetWidth
          }

          canv_width = window.innerWidth - sidebarWidth - sidepanel_width;
        }

        var canvasDimHeightSubtractor = 0;
        if(!TeacherDataService.inTeacherAgendaView && !TeacherDataService.isTeacherWorkspaceView){
          if(PlatformService.isMobile && !PlatformService.isPhonePortrait() && $rootScope.isOCMT){
            canvasDimHeightSubtractor = 95;
          }
          else{
            canvasDimHeightSubtractor = 135;
          }
        }
        else{
          canvasDimHeightSubtractor = 35;
        }

        if(map_config.hide_bottom_panel){
          canvasDimHeightSubtractor = 35;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - canvasDimHeightSubtractor
        }

        _canvasEl.width = canvasDimention.width;
        _canvasEl.height = canvasDimention.height;

        meta_background.width = canvasDimention.width;
        meta_background.height = canvasDimention.height;


        renderer.resize(canvasDimention.width, canvasDimention.height);
        cloud_man.onResize(canvasDimention.width, canvasDimention.height);

        
        scope.overlay_top = '50px'

        if(bg_images && bg_images.length > 0){
          _.each(bg_images, function(img){
            if(img.config.type === 'regular'){
              if(img.config.dimensions){
                var img_scale = (canvasDimention.width/window.innerWidth)*img.config.dimensions.width;

                if (img.config.is_container_image) {
                  img_scale = img.config.dimensions.width;
                }

                img.reference.scale.set(img_scale, img_scale)
              }

              img.reference.position.x = img.config.position.is_proportion ? canvasDimention.width * img.config.position.x : img.config.position.x;

              var heightDifferential = (TeacherDataService.isTeacherWorkspaceView || TeacherDataService.inTeacherAgendaView) && img.config.is_container_image ? 100 : 0;

              if (img.config.is_container_image) {
                img.reference.position.y = img.config.position.y;
              }
              else {
                img.reference.position.y = img.config.position.is_proportion ? canvasDimention.height * img.config.position.y - heightDifferential : img.config.position.y - heightDifferential;
              }


            }else if(img.config.type === 'tiling'){
              img.reference.position.x = img.config.position.is_proportion ? canvasDimention.width * img.config.position.x : img.config.position.x;
              img.reference.position.y = img.config.position.is_proportion ? canvasDimention.height * img.config.position.y : img.config.position.y;
              if(img.config.dimensions){
                img.reference.width = img.config.dimensions.width <= 1 ? canvasDimention.width * img.config.dimensions.width : img.config.dimensions.width;
                img.reference.height = img.config.dimensions.height <= 1 ? canvasDimention.height * img.config.dimensions.height : img.config.dimensions.height;
              }
            }

            if(img.config.hide_in_submodule){
              img.reference.visible = !scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0;
            }
          })
        }

        if(container && renderer){
          if(PlatformService.isMobile && $rootScope.isOCMT){
            let mScale;
            let mContainerX;
            let mContainerY;

            if(window.orientation === 0){
              mScale = canvas_el.clientWidth * 0.00067633;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.52;
            }
            else{
              mScale = canvas_el.clientWidth * 0.0005;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.75;
            }
            container.scale.set(mScale, mScale);
            container.x = mContainerX;
            container.y = mContainerY;
          }
          else{
            scale = renderer.width < 800 ? Math.max(0.2655, 0.45 * renderer.width/800) : scale;
            if(renderer.height < 800 && scope.currentActiveSubModule && scope.currentActiveSubModule.slug && scope.currentActiveSubModule.slug.indexOf('run_like_math') > -1){
              scale = Math.max(0.2655, 0.45 * Math.min(renderer.height, renderer.width)/800);
              scope.overlay_scale = Math.min(1, scale * 2);
              scope.overlay_top = 50*scope.overlay_scale+'px'
            }else{
              scope.overlay_scale = null;
            }
            container.scale.set(scale, scale);

            if(map_config.zoom_start_difference && renderer.width < 800){
              scope.zoom_function(map_config.zoom_start_difference*-1);
            }
            if(focus_item && !map_config.disable_panning && !map_config.disable_auto_pan){
              var abs_pos = container.toGlobal(focus_item.sprite.position);
              container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
              container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
            }else{
              container.x = renderer.width / 2;
              container.y = renderer.height / 2;
            }
          }          
              
          if(window.innerWidth < 1225 && TeacherDataService.inTeacherAgendaView){
            scope.overlay_top = '30%';
          }

          scope.canv_width = canvasDimention.width + 'px'
        }
      };

      //this is what runs to initialize the map
      var loadAssets = function() {
        $log.debug('[[gr78MetaMap]] loadAssets')
        return $q(function(resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader
                .add(img_asset_paths)
                .load(function() {
                  PIXI_gr78_Load_Cache = true;
                  initMap(resolve);
                })
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err)
            reject(err);
          }
        })
      }

      //remove when rlm integration done
      scope.slugs = {
        addition:["run_like_math_addition_lv_1","run_like_math_addition_lv_2","run_like_math_addition_lv_3","run_like_math_addition_lv_4","run_like_math_addition_lv_5","run_like_math_addition_lv_6","run_like_math_addition_lv_7","run_like_math_addition_lv_8","run_like_math_addition_lv_9","run_like_math_addition_lv_10"],
        subtraction:["run_like_math_subtraction_lv_1","run_like_math_subtraction_lv_2","run_like_math_subtraction_lv_3","run_like_math_subtraction_lv_4","run_like_math_subtraction_lv_5","run_like_math_subtraction_lv_6","run_like_math_subtraction_lv_7","run_like_math_subtraction_lv_8","run_like_math_subtraction_lv_9","run_like_math_subtraction_lv_10"],
        division:["run_like_math_division_lv_1","run_like_math_division_lv_2","run_like_math_division_lv_3","run_like_math_division_lv_4","run_like_math_division_lv_5","run_like_math_division_lv_6","run_like_math_division_lv_7","run_like_math_division_lv_8","run_like_math_division_lv_9","run_like_math_division_lv_10"],
        multiplication:["run_like_math_multiplication_lv_1","run_like_math_multiplication_lv_2","run_like_math_multiplication_lv_3","run_like_math_multiplication_lv_4","run_like_math_multiplication_lv_5","run_like_math_multiplication_lv_6","run_like_math_multiplication_lv_7","run_like_math_multiplication_lv_8","run_like_math_multiplication_lv_9","run_like_math_multiplication_lv_10"]
      }
      scope.isRlm = function(mod){
        return mod && (mod.id === 192 || mod.parent_resource_id === 192);
      }
      //done remove

      var initMap = function(resolve) {
        $log.debug('[[gr78MetaMap]] initMap')
        modules = [];
        var i, n, p;

        for (i = 0; i < scope.moduleMapData.resources.length; i++) {
          if((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)){
              //hide these
          }else{
            initMapDraw(scope.moduleMapData.resources[i]);
              if ((!ModuleFilter.checkAvailable(scope.moduleMapData.resources[i]) && map_config.hide_on_lock) || scope.moduleMapData.resources[i].parent_resource_id === 192) {
                continue;
              }
              var module_container = createModuleContainer(scope.moduleMapData.resources[i]);
              modules.push(module_container);
          }

          //Add all the bad boys to the verlet_system
        }
        //moduleContainerManager.translationChanged();
        $log.debug('[[gr78MetaMap]] initMap.initMapDraw done')

        verlet_system.deactivateAllBodies(true);

        for (i = 0; i < modules.length; i++) {
          verlet_system.activateBody(modules[i].slug, true);
        }
        $log.debug('[[gr78MetaMap]] initMap.verlet_system done')
        var active_module = MapStateService.getActiveModule();
        for (n = 0; n < modules.length; n++) {
          if (modules[n].slug === active_module) {
            moduleClicked(modules[n]);

            var active_items = MapStateService.getActiveItems();

            verlet_system.deactivateAllBodies(true);

            for (p = 0; p < active_items.length; p++) {
              var item = getItemBySlug(active_items[p]);
              var pos = MapStateService.getItemState(active_items[p]);
              if (!item) {
                continue;
              }
              item.sprite.position.x = pos.x;
              item.sprite.position.y = pos.y;
              verlet_system.activateBody(active_items[p], true);
            }
          }
        }

        if(!map_config.selection_disabled){          
          selection_graphic = new PIXI.Sprite(PIXI.loader.resources[map_config.asset_url + 'selection.png'].texture);
          selection_graphic.anchor.set(0.5,0.5);
          selection_graphic.scale.set(0.75,0.75);
          selection_graphic.interactive = false;
          selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
        }


        if (!PanelStateService.agendaShowing())
        {
          scope.toggleAgenda();
        }

        //If an item was selected before we left the map, find it and highlight it as we return.
        var focus_slug = MapStateService.getFocusSlug();
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++) {
            if (scope.moduleMapData.resources[n].children[i].slug === focus_slug) {
              var item_info = scope.moduleMapData.resources[n].children[i];
              // var item_evt_info = {
              //   slug : item_info.slug,
              //   id : item_info.id
              // };
              //brodcast the selection events
              eventManager.broadcast('module:center:resource', item_info);
              eventManager.broadcast('module:select:resource', item_info);
              if (focus_item === null || map_config.disable_panning || map_config.disable_auto_pan) {
                break;
              }
              //center on the resource immediately
              if(focus_item){
                var abs_pos = container.toGlobal(focus_item.sprite.position);
                container.x += -(abs_pos.x - 125 - app.renderer.width / 2);
                container.y += -(abs_pos.y + 80 - app.renderer.height / 2);
              }

              break;
            }
          }
        }
        if (focus_item)
        {
          if (scope.moduleMapData.resources[n] !== undefined && scope.moduleMapData.resources[n].children[i] !== undefined)
          {
            $timeout(function(){
              scope.panelDisplay = scope.moduleMapData.resources[n].children[i];
            }, TIMING_CONSTANTS.INSTANT);
          }
        }

        if(PlatformService.isMobile&& $rootScope.isOCMT){
          $timeout(function(){
            let mScale;
            let mContainerX;
            let mContainerY;

            if(window.orientation === 0){
              mScale = canvas_el.clientWidth * 0.00067633;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.52;
            }
            else{
              mScale = canvas_el.clientWidth * 0.0005;
              mContainerX = canvas_el.clientWidth / 2;
              mContainerY = canvas_el.clientHeight * 0.75;
            }
            container.scale.set(mScale, mScale);
            container.x = mContainerX;
            container.y = mContainerY;
          }, 100)
        }
        else{
          if(map_config.zoom_start_difference){
            $timeout(function(){
              scope.zoom_function(map_config.zoom_start_difference*-1);
            }, 100)
          }
        }

        $log.debug('[[gr78MetaMap]] initMap.active_module done')
        resolve();

        eventManager.broadcast('creating-items-done');
        if(prehighlighted_list && prehighlighted_list.length > 0){
            _.each(prehighlighted_list, function(el) {
              var item = getItemById(el);
              if(item){
                item.showAgendaHighlight(true);
              }
            });
        }
      }

      var module_clicked = false;
      var moduleClicked = function(module_container) {
        if((module_container.slug === 'mtic_c3_m1v2' ||module_container.slug === 'mtic_c3_m1' || module_container.slug === 'mtic_c3_m3') && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)){
          window.alert('Some of the video items are currently not supported on Internet Explorer. Please use a different browser for the best results.')
        }
        if((module_container.slug === 'mtic_c3_m56' || module_container.slug === 'mtic_gr910_m1' || module_container.slug === 'mtic_gr910_m2') &&
          PlatformService.isMobile &&
          !window.confirm('This module is not optimized for mobile devices. Please use a different device for the best results.')){
            return;
        }
        if(module_container.slug === 'mtic_c3_m56' && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
          window.alert('This module is currently not supported on Internet Explorer. Please use a different browser to access this module.');
          return;
        }

        if(scope.interactionDisabled || (scope.agendaView && module_container.id === 192)){
          return;
        }
        module_clicked = true;

        // $log.log('MODULE CONTAINER : ', module_container)
        if(ModuleFilter.checkAvailable(module_container)) {
          if(scope.interceptClick){
            if(scope.interceptClick.slug !== module_container.slug){
              scope.interceptClick.slug = module_container.slug;
            }else if(!TeacherDataService.inTeacherAgendaView){
              // eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }

            scope.$apply();
          }
          var i;
          scope.moduleProgress = module_container.progress;
          $log.debug('[[gr78MetaMap]] clicked', module_container)

          if(module_container.content.container) {
            scope.loadedIframeModule.data = module_container;
            scope.loadedIframeModule.active = true;
          }
          else{
            for (i = 0; i < modules.length; i++) {
              modules[i].graphics.interactive = false;

              verlet_system.deactivateBody(modules[i].slug, true);
            }
            eventManager.broadcast('submodule:opened', {
              slug: module_container.slug,
              name: module_container.name
            })

            $timeout(function(){
              onResize();
            }, 10)
            $timeout(function() {
              eventManager.broadcast('module:change:submodule', module_container.slug);
            }, TIMING_CONSTANTS.INSTANT);
          }
        }else{
          window.alert(language.get('module_is_locked'))
        }
      }

      var createModuleContainer = function(module, reset) {
        //Set up the container sprite that will be used
        var do_lock = module.locked;
        //$log.log("MODULE : " , module)//DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(module.slug) > -1
        // $log.log('ModuleFilter.checkAvailable(module)', ModuleFilter.checkAvailable(module))
        if (!ModuleFilter.checkAvailable(module)) {
          do_lock = true;
        }
        //For drawing progress ring
        var sum = 0;
        var prog = 0;
        var formative_count = 0;
        var lesson_count = 0;

        module.progress_rings = {diagnostic: 0, lessons: 0, summative: 0, summative_complete: false};

        for (var i = 0; i < module.children.length; i++)
        {
          var child = module.children[i];

          if(child.resource_type === 'lesson'){
            module.progress_rings.lessons += child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
            lesson_count++;
          } else if(child.config.assessment_type && child.config.assessment_type === 'diagnostic'){
            module.progress_rings.diagnostic = child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
          } else if(child.config.assessment_type && child.config.assessment_type === 'formative' && !module.progress_rings.summative_complete){
            module.progress_rings.summative += child.complete && child.resourceState.score_max ? child.resourceState.score_max : 0;
            formative_count++;
          } else if(child.config.assessment_type && child.config.assessment_type === 'summative'){
            if(child.complete){
              module.progress_rings.summative_complete = true;
            }
            module.progress_rings.summative = child.complete && child.resourceState.score_max ? child.resourceState.score_max : module.progress_rings.summative;
          }

          if (child.resource_type === 'symlink' || (child.resource_type === 'assessment'  && child.config.assessment_type && child.config.assessment_type === 'formative'))
          {
            continue;
          }
          sum ++;
          if(TeacherDataService.isTeacherWorkspaceView){
            prog += workspace_list[child.id] ? 1 : 0;
          }else{
            prog += child.complete ? 1 : 0;
          }

        }

        if(!module.progress_rings.summative_complete && formative_count > 0){
          module.progress_rings.summative = module.progress_rings.summative/formative_count;
        }
        module.progress_rings.lessons = module.progress_rings.lessons/lesson_count;

        let getProgressRingColor = (val) => {
          let color = '';
          if(val <= 0.5){color = 'red'}
          else if(0.5 < val && val <= 0.8){color = 'yellow'}
          else {color = 'green'}
          return color
        }

        module.progress_rings = {
          diagnostic: {
            value: Math.round(module.progress_rings.diagnostic*100),
            color: getProgressRingColor(module.progress_rings.diagnostic)
          },
          lessons: {
            value: Math.round(module.progress_rings.lessons*100),
            color: getProgressRingColor(module.progress_rings.lessons)
          },
          summative: {
            value: Math.round(module.progress_rings.summative*100),
            color: getProgressRingColor(module.progress_rings.summative),
            complete: module.progress_rings.summative_complete
          }
        }

        if(TeacherDataService.isTeacherModuleView){
          prog = 0;
        }
        var mod_graphics;
        if(reset){
          modules.forEach(function(mod){
            if(mod.slug === module.slug){
              mod_graphics = mod.graphics;
            }
          })
          //mod_graphics = container.getChildAt(0);
          if(!mod_graphics){
            return;
          }
          mod_graphics.clear();
          mod_graphics.removeChildren();
        }else{
          mod_graphics = new PIXI.Graphics();
        }
        // mod_graphics.beginFill(do_lock ? 0xC5FBF5 : 0xFFFFFF).drawCircle(0, 0, 145).endFill() //white border
        // .moveTo(0, 0)
        // .beginFill(0x33ACE0).arc(0,0,146,-Math.PI/2, (prog/sum)*Math.PI*2-Math.PI/2); //progress ring
        var mod_graphic_url = map_config.use_panel_factory_icon_names ? PanelFactory.getModuleIconAssetUrl(module.slug) : map_config.asset_url + (do_lock ? "center_lock" : module.slug) + ".png";
        if(map_config.set_module_icon_names){
          mod_graphic_url = map_config.set_module_icon_names[module.slug] || map_config.set_module_icon_names.default;
          mod_graphic_url = map_config.asset_url + mod_graphic_url + ".png";
        }
        var mod_image = PIXI.Sprite.fromImage(mod_graphic_url);
        mod_image.anchor.set(0.5);
        var img_size = module.slug.indexOf('ocmt') > -1 ? 325 : 250;
        mod_image.width = module.display.width || img_size;
        mod_image.height = module.display.height || img_size;
        mod_graphics.addChild(mod_image);

        container.addChild(mod_graphics);
        mod_graphics.buttonMode = true;
        mod_graphics.interactive = true;
        mod_graphics.x = module.display.position.x;
        mod_graphics.y = module.display.position.y + 300;
        // if(module.id === 69){
        //   mod_graphics.y -= 30;
        // }

        var tooltip = new PIXI.Graphics();
        mod_graphics.addChild(tooltip);
        var mod_graphics_height = mod_graphics.height;

        var drawTooltip = () => {
          tooltip.removeChildren();
          tooltip.clear();
          var height_diff = module.config.is_new ? 70 : 0;
          var padding = map_config.tooltip_options.padding || 0;
          var textInfo = new PIXI.Text(language.get(module.slug), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: isMobile ? 40 : 32,
            fill: Number(map_config.tooltip_options.fontcolor),
            dropShadow: false,
            wordWrap: true,
            wordWrapWidth: map_config.tooltip_options.wordwrap_width || 300
          });
          textInfo.y = textInfo.height/2 + 5 + height_diff + padding/2;
          textInfo.anchor.set(0.5);
          
          let title_width = textInfo.width;

          if(module.config.is_new){     
            title_width = Math.max(title_width, new PIXI.Text(language.get('updated_slug')).width * 1.1 + 40);
          }

          var text_width = title_width + padding;
          var rectHeight = do_lock ? textInfo.height + 15 + padding : textInfo.height + 35 + padding;

          var triangly_y_start = map_config.tooltip_options.inverted ? 0 : rectHeight;
          var triangly_y_end = map_config.tooltip_options.inverted ? -25 : rectHeight + 25;

          tooltip.beginFill(do_lock ? Number(map_config.tooltip_options.locked_color) : Number(map_config.tooltip_options.color))
          .drawRoundedRect(-(text_width+40)/2,0, text_width+40, rectHeight+height_diff, 10).endFill();

          if(module.config.is_new){
            if(!map_config.tooltip_options.inverted){
              triangly_y_start += height_diff;
              triangly_y_end += height_diff;
            }
            tooltip.lineStyle(0);
            tooltip.beginFill(map_config.tooltip_options.new_mod_color);
            tooltip.drawRoundedRect(-(text_width+40)/2, 0, text_width+40, height_diff-10, 10);              
            tooltip.drawRect(-(text_width+40)/2, height_diff-20, text_width+40, 20);
            tooltip.endFill();
            
            var mod_update_text = new PIXI.Text(language.get('updated_slug'));
            mod_update_text.anchor.set(0.5);
            mod_update_text.style.align = "center";
            mod_update_text.style.fill = "white";
            mod_update_text.style.fontFamily = "Helvetica";
            mod_update_text.style.fontSize = 36;
            mod_update_text.x = 0;
            mod_update_text.y = 38;
            tooltip.addChild(mod_update_text);
            update_texts.push(mod_update_text)
          }

          tooltip.beginFill(do_lock ? Number(map_config.tooltip_options.locked_color) : module.config.is_new && map_config.tooltip_options.inverted ? map_config.tooltip_options.new_mod_color : Number(map_config.tooltip_options.color))
          tooltip.moveTo(-15,triangly_y_start);
          tooltip.lineTo(15,triangly_y_start);
          tooltip.lineTo(0,triangly_y_end);
          tooltip.lineTo(-15,triangly_y_start);
          tooltip.endFill();

          if(!do_lock && !map_config.tooltip_options.no_bar){
            tooltip.beginFill(Number(map_config.tooltip_options.bar_color));
            tooltip.drawRect(-(text_width+40)/2+10, textInfo.height + 10 + height_diff + padding/2, text_width+20, 15);
            tooltip.endFill();

            tooltip.beginFill(Number(map_config.tooltip_options.bar_fill_color));
            tooltip.drawRect(-(text_width+40)/2+10, textInfo.height + 10 + height_diff + padding/2, (text_width+20) * (prog/sum), 15);
            tooltip.endFill();
          }

          tooltip.addChild(textInfo);

          tooltip.y = map_config.tooltip_options.inverted ? mod_graphics_height/2 + 50: -1*mod_graphics_height/2 - tooltip.height;
          textInfo.x = tooltip.width/2 - title_width/2 - 20;
        }


        eventManager.listen('language:change', drawTooltip);
        drawTooltip();


        var module_container = {
          graphics: mod_graphics,
          slug: module.slug,
          id: module.id,
          name: module.name,
          content: module.content,
          children: module.children,
          progress: prog/sum
        };
        if(reset){
          mod_graphics.off('pointertap')
        }
        mod_graphics.on('pointertap', function(e){
          //PIXI is receiving mouse events from other targets
          if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'module-item-map-canvas') {
            return;
          }
          $timeout(function(){
            if(!zooming){
              moduleClicked(module_container);
            }
          }, 10)
        });


        // eventManager.listen('destroy-c3-map', function(){
        //   PIXI_gr78_Load_Cache = false;
        // })


        eventManager.listen('module:dismiss:focus', function(e, data) {
          scope.selectedResource = {};
          if (selection_graphic && selection_graphic.parent !== null)
          {
            selection_graphic.parent.removeChild(selection_graphic);
          }
        });

        eventManager.listen('triggerMapResize', function(){
          $timeout(function(){
            onResize()
          }, 100)
        })

        var connection = [];
        if (modules.length > 0) {
      //    connection.push(modules[modules.length - 1].slug);
        }

        verlet_system.createBody(module.slug, mod_graphics, connection);
        return module_container;
      }

      var loadChildren = function(someItem) {
        someItem.childResourcemap = [];

        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function(childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      }
      var interpeteAgendaLockStatus = function(agenda){
        if(agenda.force_unlock === true) {
          return 'unlock';
        } else if(agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      }

      var summative_list = [];

      eventManager.listen('got-c4-summative-data', function(e, args) {
        $timeout(function(){
          summative_list.forEach(function(summ){
            if(args && args.unlocked.indexOf(summ.name) > -1){
              // $log.log(MapStateService.getActiveModule());
              var name_check = summ.val.slug.replace('g78', 'gr78')
              args.force_unlock = args.force_unlock || [];
              var start_visible = MapStateService.getActiveModule() && summ.val.config.assessment_type === 'summative' && name_check.indexOf(MapStateService.getActiveModule()) > -1;
              createItem(summ.val, summ.parent, !start_visible, true, args.force_unlock.indexOf(summ.name) > -1);
            }
          })
        }, 500)

      });

      var createItem = function(resource, parentItem, start_hidden, build, force_unlock) {
        var isSummative = false;
        if((resource.slug.indexOf('summative') > -1 || resource.config.assessment_type === 'summative') && !resource.config.show_summative){
          isSummative = true;
          if(!build && !TeacherDataService.isTeacherModuleView && !TeacherDataService.isTeacherWorkspaceView) {
            summative_list.push({name: resource.slug, val: resource, parent: parentItem})
            return;
          }
        }else if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function(childItem) {
              createItem(childItem, resource);
            });
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        if (TeacherDataService.isTeacherModuleView || TeacherDataService.isTeacherWorkspaceView){
          resource.locked = false;
        }
        //Add this to the map logic array of items
        items.push(displayItem = new itemFactory.createMapItem(resource, eventManager, parentItem && parentItem.map_config ? parentItem.map_config : scope.moduleMapData.meta_config.map_config));
        resourceLockManager.setOriginal(displayItem.id, displayItem.locked)
        //create a VerletBody for the item
        displayItem.parentItem = parentItem;
        //     displayItem.sprite.position.x += Math.random() * 10;
        //    displayItem.sprite.position.y += Math.random() * 10;
        container.addChild(displayItem.sprite);

        var children = [];
        //Build the child items
        _.forEach(resource.children, function(childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        if(map_config.map_style === 'ocmt'){
          displayItem.addSemiRing();
          displayItem.addBottomLineGraphics();
        }

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }


        // displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if(!isSummative){
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        }else{
            displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, false, !resource.complete);
        }
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }
        if(map_config.position_multiplier){
          displayItem.sprite.position.x = displayItem.sprite.position.x*  map_config.position_multiplier;
          displayItem.sprite.position.y = displayItem.sprite.position.y*  map_config.position_multiplier;
        }
        if(PlatformService.isMobile && resource.slug.indexOf('run_like_math') > -1){
          displayItem.sprite.position.y += 125;
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        if(isSummative){
          // resource.locked = resource.unlocked_by && resource.unlocked_by.length > 0 ? resource.locked : false;
          if(force_unlock){
            displayItem.unlock(true);
          }
          if(!map_config.summative_pos_from_db){
            displayItem.sprite.position.x = -900;
            displayItem.sprite.position.y = -500;
          }
        }
        // if(prehighlighted_list.indexOf(resource.id) > -1){
        //   $log.log('PREHIGHLIGHTING : ', resource.slug)
        //   $timeout(function(){
        //     displayItem.showAgendaHighlight(true);
        //   }, 100);
        // }
        return displayItem;
      }


      scope.$on('$destroy', function() {
        // language.resetAvilableOptions();
        EXISTS = false;
        MapStateService.setActiveModule("");
        //first save the state
        var active_items = verlet_system.getActiveSlugs();

        for (var i = 0; i < active_items.length; i++) {
          var item = getItemBySlug(active_items[i]);
          if(item) {
            MapStateService.setItemState(active_items[i], {
              x: item.sprite.position.x,
              y: item.sprite.position.y
            });
          }
        }

        MapStateService.setActiveItems(active_items);

        PIXI.loader.reset();
        PIXI_gr78_Load_Cache = false;

        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {

          canvas_el.getContext('webgl').getExtension('WEBGL_lose_context').loseContext();
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll); // for Firefox
          canvas_el.removeEventListener('mousewheel', handleScroll); // for everyone else

          // prevent browser from selecting other html text when double clicking the PIXI canvas
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        verlet_system.clear();
        
        if(stage){
          stage.destroy(true);
          stage = null;
        }
        if(app){
          app.renderer.destroy(true);
          app.renderer = null;
        }
        modules = [];
        window.removeEventListener("resize", onResize);
      });

      scope.$watch("moduleMapData", function(moduleMapData) {
        if(!moduleMapData){
          return;
        }
        language.setAvailableOptions(
          _.get(moduleMapData, ['content', 'available_languages', LocaleService.getUrlVersion()])
        );
        for (var i = 0; i < moduleMapData.resources.length; i++) {
          switch (moduleMapData.resources[i].slug) {
            case 'mtic_gr78_m2':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapTwo(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m1':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
            case 'mtic_gr78_m6':
              moduleMapData.resources[i].children = MapDataMassage.massageResourceMapOne(moduleMapData.resources[i].children);
              break;
          }
        }

        
        $timeout(function(){
          MapStateService.setCurrentItemLang("");
        }, 1000)

        if (!moduleMapData || EXISTS) {
          return;
        }


        var timer = window.isWebEmbedConnect ? 500 : 0;
        $timeout(()=>{
          EXISTS = true;
          init();
        }, timer);
      })

      eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
        for (var i = 0; i < items.length; i++) {
          //items[i].hideAgendaHighlight();
        }
        if (!agenda || !agenda.resources)
        {
          return;
        }
        switch(interpeteAgendaLockStatus(agenda)) {
          case 'unlock':
            return resourceLockManager.unlock(agenda.resources);
          // case 'lock':
          //   return resourceLockManager.lock(agenda.resources);
          // default:
          //   return resourceLockManager.reset();
        }
      });


      var workspace_list = {};
      var users_list = [];
      scope.$watch('[workspaceData.users, workspaceData.modules]', function(val){
        var timer = window.isWebEmbedConnect && TeacherDataService.isTeacherWorkspaceView ? 500 : 50;
        //$log.log('workspace data : ' , scope.workspaceData)
        $timeout(function(){
          if(scope.workspaceData && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)){
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach( function(user){
              users_list.push(user.user_id);
            })

            scope.workspaceData.modules.forEach( function(work){
              if(users_list.indexOf(work.user_id) > -1){
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            })

            //modules.forEach(function(built_mod){
              //container.removeChild(built_mod.graphics);
            //})

            // modules = [];
            for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
              if((navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) && (scope.moduleMapData.resources[i].id === 923 || scope.moduleMapData.resources[i].id === 955)){
                  //hide these
              }else{
                var module_container = createModuleContainer(scope.moduleMapData.resources[i], true);
                //modules.push(module_container);
              }
            }
          }
        }, timer)

      })

        scope.itemSearchChange = function(val){
          scope.filteredNameList = [];
          if(!scope.itemsNameList){
            return;
          }
          if(val.trim() !== ''){
            scope.filteredNameList = scope.itemsNameList.filter(function(name){
              var nameMod = name.name.toLowerCase();
              var valMod = val.toLowerCase();
              var bool_val;
              try{
                bool_val = nameMod.match(valMod)
              }catch(e){
                bool_val = false
              }
              return bool_val;
            })
          }
          // $log.log('scope.filteredNameList', scope.filteredNameList);
        }

        scope.view_controller = {
          isStudentView: true,
          isModulePanelView: true,
          openSubMod: function(slug){
            // $log.log('opening sub mod:', slug)
            $timeout(function(){
              eventManager.broadcast('module:change:submodule', slug);
            }, 1000)
          },
          openMainMod: function(slug){
            eventManager.broadcast('module:change:meta', 'mtic_gr78_m_meta');
          }
        }

        eventManager.listen('sidepanel:toggled', function(e, val){
          if(!PlatformService.isPhonePortrait()){
            onResize(val);
          }
        })

        eventManager.listen('hide_item_selection_highlight', function(e, resource){
          var item = getItemBySlug(resource.slug);
          item.hideAgendaHighlight(true);
        })

        eventManager.listen('toggle_item_selection_highlight', function(e, slug){
          var item = getItemBySlug(slug);
          item.showAgendaHighlight();
        })

        scope.zoom_function = function(val){
          handleScroll({detail: val, preventDefault: ()=>{}})
          zooming = true;
          $timeout(function(){
            zooming = false
          }, 10)
        }

        eventManager.listen('offline-post-call-resolved', function(){
          if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0 || !module_clicked){
            for(var texture in PIXI.TextureCache){
              var tmp = PIXI.Texture.removeTextureFromCache(texture);
              tmp.destroy(true);
            }
            eventManager.broadcast('refresh:current:tab');
            eventManager.broadcast('student:cycle:open');
          }
        });


        MapStateService.setItemOptions({training_mode : true});
        scope.set_rlm_option = function(option, init){
          if(init){
            var item_options = MapStateService.getItemOptions();
            if(item_options && item_options.training_mode === false){
              option = 'challenge';
            }
          }
          scope.rlm_option_selected = option;
          MapStateService.setItemOptions({training_mode : option === 'training'});
        }

    }
  }
});

var PIXI_gr78_Load_Cache;
var EXISTS;
